// extracted by mini-css-extract-plugin
export default {"basketPopup":"basketPopup_basketPopup__-cOa2","close":"basketPopup_close__ixQXB","title":"basketPopup_title__TBagl","btn":"basketPopup_btn__RNpUc"};